<template>
  <div class="maintain" v-if="funcView.feed_back_manage_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-button type="primary" icon="el-icon-plus" @click="onAdd" v-if="funcView.feed_back_manage_add">
            {{ funcView.feed_back_manage_add }}
          </el-button>
        </el-form-item>
        <el-form-item v-if="funcView.feed_back_manage_export" style="float: right; margin-right: 0">
          <el-button class="table-set" @click.native="exportTable('feedbackExport', { ...formSearch, exportTableCode: tableCode })">
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right" :style="{ 'margin-right': !funcView.feed_back_manage_export ? 0 : '' }">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('asm_undone.jshgdbhljbhljmc')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('asm_undone.shen_qing_shi_jian')">
          <custom-date-picker
            v-model="formSearch.dataTimes"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="pickerOptionDisAfter"
            style="width: 100%"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('asm_undone.chan_pin_xing_hao')">
          <custom-select
            url="productCodeSelectList"
            v-model="formSearch.productCode"
            :props="{ label: 'productCode', value: 'productCode' }"
            :placeholder="$t('Common.com_please_select')"
            width="100%"
          ></custom-select>
        </el-form-item>
        <el-form-item :label="$t('asm_undone.shen_qing_zu_zhi')">
          <el-input v-model="formSearch.applyOrgName"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>

    <div class="table-bd">
      <custom-table height="100%" :data="tableList" @filter="filterChange" @sort="sortChange" @column="setColumn" :slots="['workOrderCode', 'action']" :tableCode="tableCode" :key="tableCode">
        <template v-slot:workOrderCode="scope">
          <span class="watch-detail" @click="watchDetail(scope.row)">{{ scope.row.workOrderCode }}</span>
        </template>
        <template v-slot:action="scope">
          <!-- 查看 -->
          <el-button type="text" size="mini" @click="onPreview(scope.row)" v-if="flowNodeNo !== 0 && funcView.feed_back_manage_preview">{{ funcView.feed_back_manage_preview }}</el-button>
          <!-- 审批 -->
          <el-button type="text" size="mini" @click.native="onApproval(scope.row)" v-if="isHq && funcView.feed_back_manage_apply">{{ funcView.feed_back_manage_apply }}</el-button>
          <!-- 更多操作 -->
          <el-dropdown style="vertical-align: top" v-show="scope.row.showMoreAction">
            <el-button type="text" size="mini">
              <span>{{ $t('Common.com_more_action') }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <!-- 草稿才能提交 -->
              <el-dropdown-item v-if="!isHq && flowNodeNo === 0 && funcView.feed_back_manage_submit" @click.native="onSubmit(scope.row)">
                {{ funcView.feed_back_manage_submit }}{{ showMore(scope.row) }}
              </el-dropdown-item>
              <!-- 草稿才能编辑 -->
              <el-dropdown-item v-if="!isHq && flowNodeNo === 0 && funcView.feed_back_manage_edit" @click.native="onEdit(scope.row)">
                {{ funcView.feed_back_manage_edit }}{{ showMore(scope.row) }}
              </el-dropdown-item>
              <!-- 删除 -->
              <el-dropdown-item v-if="!isHq && flowNodeNo === 0 && funcView.feed_back_manage_delete" @click.native="onDel(scope.row)">
                {{ funcView.feed_back_manage_delete }}{{ showMore(scope.row) }}
              </el-dropdown-item>
              <!-- 打印 -->
              <el-dropdown-item @click.native="onPrint(scope.row)" v-if="flowNodeNo !== 0 && funcView.feed_back_manage_print">{{ funcView.feed_back_manage_print }}{{ showMore(scope.row) }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <!-- 列表创建的新增编辑 -->
    <feedBack-item-dialog v-if="dialogVisible" @close="dialogVisible = false" :model="dialogModel" @success="onPageChange({ page: 1 })"></feedBack-item-dialog>
    <!-- 工单创建的编辑 -->
    <feedBack-edit-dialog v-if="dialogVisible1" @close="dialogVisible1 = false" :model="dialogModel1" @success="onPageChange({ page: 1 })"></feedBack-edit-dialog>
    <feedBack-print-dialog v-if="dialogVisible2" @close="dialogVisible2 = false" :model="dialogModel2"></feedBack-print-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';
import feedBackItemDialog from '@/pages/asm/components/feedBack_item_dialog';
import feedBackEditDialog from './feedBack_edit_dialog';
import feedBackPrintDialog from './feedBack_print_dialog';

export default {
  name: 'undone',
  mixins: [resetFormSearchMixins],
  components: {
    feedBackItemDialog,
    feedBackEditDialog,
    feedBackPrintDialog,
  },
  props: {
    flowNodeNo: [Number],
    isHq: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        type: 1,
        flowNodeNo: '',
        dataTimes: '',
        startTime: '',
        endTime: '',
        productCode: '',
      },
      totalRows: null,
      tableList: [],
      productCodes: [],
      // 新增编辑项目
      dialogModel: {},
      dialogVisible: false,
      // 编辑工单项目
      dialogModel1: {},
      dialogVisible1: false,
      // 打印
      dialogModel2: {},
      dialogVisible2: false,
      link: null,
    };
  },
  computed: {
    tableCode() {
      if (this.isHq) {
        return 'feedBack_hq_undone';
      }
      // 售后未完成
      if (this.flowNodeNo === 1) {
        return 'feedBack_doing';
      }

      return 'feedBack_undone';
    },
  },
  watch: {
    flowNodeNo() {
      this.onPageChange({ page: 1 });
    },
  },
  filters: {},
  directives: {},
  methods: {
    // 更多操作
    showMore: function (row) {
      this.$set(row, 'showMoreAction', true);
      return '';
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    getTableList() {
      this.formSearch.startTime = this.formSearch.dataTimes && this.formSearch.dataTimes[0] ? this.formSearch.dataTimes[0] : undefined;
      this.formSearch.endTime = this.formSearch.dataTimes && this.formSearch.dataTimes[1] ? this.formSearch.dataTimes[1] : undefined;
      this.formSearch.type = this.flowNodeNo === 0 ? 0 : 1;
      this.formSearch.flowNodeNo = this.flowNodeNo;
      this.$getJSON(apis.feedbackPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    onSubmit(row) {
      const { feedBackId, feedBackDesc } = row;
      if (!feedBackDesc) {
        this.$message.error(this.$t('asm_undone.qxtxgzms'));
        return;
      }
      this.$showConfirm(this.$t('asm_undone.nqdytjxzdfkxxm')).then(() => {
        this.$postJSON(
          `${apis.apsApproveApprovalApproveStart}/${'feed_back'}/${feedBackId}`,
          {
            title: [`【${feedBackId}】`, this.getDicValue('approval_type', 'feed_back')].join(' '),
            applyReason: feedBackDesc,
          },
          true
        ).then(() => {
          this.$message({
            type: 'success',
            message: this.i18n.com_handle_success,
          });
          this.getTableList();
        });
      });
    },
    // 跳转工单详情
    watchDetail(row, options = {}) {
      this.jump('/workorder/workOrderDetail', {
        orderType: 'workOrder',
        caseOrderType: row.workOrderType,
        caseOrderId: row.caseOrderId,
        workOrderId: row.workOrderId,
        ...options,
      });
    },
    // 查看质量反馈详情
    onPreview(row) {
      this.jump('/redirect/workorder/feedBackDetail', {
        feedBackId: row.feedBackId,
      });
    },
    onApproval(row) {
      this.jump('/examine/approvalDetail', {
        workflowType: 'feed_back',
        bizId: row.feedBackId,
        flowNodeNo: this.flowNodeNo,
      });
    },
    onEdit(row) {
      // 工单创建的
      if (row.workOrderId) {
        this.dialogModel1 = {
          title: this.$t('asm_undone.bjzlfk'),
          type: 'edit',
          data: row,
        };
        this.dialogVisible1 = true;
      } else {
        this.dialogModel = {
          title: this.$t('asm_undone.bjzlfk'),
          type: 'edit',
          data: row,
        };
        this.dialogVisible = true;
      }
    },
    onPrint(row) {
      this.dialogModel2 = {
        title: this.$t('asm_undone.zlfkbg'),
        type: 'edit',
        data: row,
      };
      this.dialogVisible2 = true;
    },
    onAdd() {
      this.dialogModel = {
        title: this.$t('asm_undone.xzzlfk'),
        type: 'add',
      };
      this.dialogVisible = true;
    },
    onDel(row) {
      this.$showConfirm(this.$t('asm_undone.nqdyscxzdfkxx')).then(() => {
        this.$postJSON(`${apis.feedbackDelete}/${row.feedBackId}`, {}, true).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_delete_success'),
          });
          this.getTableList();
        });
      });
    },
  },
  created() {},
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getTableList();
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });
  },
};
</script>

<style lang="scss" scoped>
.maintain {
  padding: 0 16px 0 16px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .watch-detail {
    text-decoration: underline;
    cursor: pointer;
    color: #0d9ae0;
  }
}
</style>
